import { HousingUnitFilters } from '@reliance/types/filters/HousingUnitFilters';
import { HousingUnit } from '@reliance/types/models/HousingUnit';
import { useAsync } from 'react-async-hook';
import api from '../common/api';
import { IPaginatedResponse } from '../common/reliance-api-service';

export function useHousingUnits(filters?: HousingUnitFilters | null) {
  return useAsync(
    async () => {
      if (filters === null) {
        return null;
      }
      return await api.get<IPaginatedResponse<HousingUnit>>('/housing-unit', { params: filters })
        .then(response => response.data);
    },
    [filters]
  );
}
